import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {PlayerConfigurationEdit} from '../models/player-configuration';

export const playerConfigurationUpdateActionTypes = {
  UPDATE: type('[Player configuration] Update'),
  UPDATE_CLIENT: type('[Player configuration] Update Client'),
  UPDATE_SUCCESS: type('[Player configuration] Update Success'),
  UPDATE_FAIL: type('[Player configuration] Update Fail'),
};

export class UpdatePlayerConfigurationAction implements Action {
  readonly type = playerConfigurationUpdateActionTypes.UPDATE;
  constructor(public payload?:  {form, config}) {}
}

export class UpdatePlayerConfigurationClientAction implements Action {
  readonly type = playerConfigurationUpdateActionTypes.UPDATE_CLIENT;
  constructor(public payload?:  {form, config}) {}
}

export class UpdatePlayerConfigurationSuccessAction implements Action {
  readonly type = playerConfigurationUpdateActionTypes.UPDATE_SUCCESS;
  constructor(public payload?: PlayerConfigurationEdit[]) {}
}

export class UpdatePlayerConfigurationFailAction implements Action {
  readonly type = playerConfigurationUpdateActionTypes.UPDATE_FAIL;
  constructor(public payload?: string) {}
}
